import { 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    Box, 
    Grid, 
    Tooltip, 
    Typography, 
    useMediaQuery,
    Container,
    Card,
    CardContent,
    CardMedia,
    Fade,
    Zoom,
    Button,
    Chip
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectCards } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import instId from "./network/instituteId";
import Network from "./network/Network";
import { useNavigate } from "react-router-dom";
import { School, PlayArrow, ArrowForward } from "@mui/icons-material";


export const ClassRoomCourses = ({ endpointsUrl }) => {

    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:900px)");
    const isTablet = useMediaQuery("(max-width:1200px)");
    const [shortsList, setShortsList] = useState([]);
    const [peviewImgVideo, setPeviewImgVideo] = useState({});
    const [coursesList, setCoursesList] = useState([]);
    const [filterCourse, setFilterCourse] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [hoveredCard, setHoveredCard] = useState(null);


    useEffect(() => {
        getAllCourses();
        // Trigger animation after component mounts
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (coursesList?.length > 0) {
            const filterCourseTags = coursesList.filter(item => {
                const tagslists = item.tags || [];
                if (tagslists.some(tag => tag.tag === "Classroom Test Series")) {
                    return item
                }
            });

            setFilterCourse(filterCourseTags);
        }
    }, [coursesList])

    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses;
        const filterCourses = course?.filter((item) =>
            item?.active === true
        );
        setCoursesList(filterCourses);
    };

    const handleCourseClick = (item) => {
        const courseId = item?.id;
        navigate(`/classroom-courses?courseId=${courseId}`)
        // if (courseId) {
        //     window.open(`http://gst.vsmarttestseries.com?courseId=${courseId}`, '_blank');
        // }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                py: { xs: 4, md: 6 },
                px: { xs: 2, md: 3 },
                background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
                overflow: 'hidden',
                minHeight: '60vh',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'radial-gradient(circle at 30% 70%, rgba(59, 130, 246, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 30%, rgba(168, 85, 247, 0.15) 0%, transparent 50%)',
                    pointerEvents: 'none',
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Cpath d="m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                    opacity: 0.5,
                    pointerEvents: 'none',
                }
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Header Section */}
                <Fade in={isVisible} timeout={800}>
                    <Box sx={{ textAlign: 'center', mb: 5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                                    borderRadius: '50%',
                                    p: 1.5,
                                    mr: 3,
                                    boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3)',
                                }}
                            >
                                <School sx={{ 
                                    fontSize: { xs: '1.8rem', md: '2.2rem' }, 
                                    color: 'white',
                                }} />
                            </Box>
                            <Typography 
                                variant="h3"
                                sx={{ 
                                    fontWeight: 700,
                                    color: 'white',
                                    fontSize: { xs: '1.6rem', md: '2.4rem' },
                                    background: 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                Classroom Test Series
                            </Typography>
                        </Box>
                        
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.8)',
                                fontSize: { xs: '0.9rem', md: '1.1rem' },
                                maxWidth: 500,
                                mx: 'auto',
                                mb: 3,
                                lineHeight: 1.6,
                                fontWeight: 400,
                            }}
                        >
                            Discover comprehensive test series designed by expert faculty
                        </Typography>
                        
                        {/* Decorative Line with Animation */}
                        <Box
                            sx={{
                                position: 'relative',
                                width: 100,
                                height: 4,
                                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                                borderRadius: 2,
                                mx: 'auto',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: 'linear-gradient(135deg, #60a5fa 0%, #a78bfa 100%)',
                                    borderRadius: 2,
                                    animation: 'shimmer 2s ease-in-out infinite alternate',
                                    '@keyframes shimmer': {
                                        '0%': { opacity: 0.5 },
                                        '100%': { opacity: 1 },
                                    }
                                }
                            }}
                        />
                    </Box>
                </Fade>

                {/* Courses Grid */}
                {filterCourse?.length > 0 && (
                    <Fade in={isVisible} timeout={1200}>
                        <Grid container spacing={3}>
                            {filterCourse.map((item, i) => (
                                <Grid item xs={12} sm={4} md={4} lg={4} key={i}>
                                    <Zoom in={isVisible} timeout={800 + i * 100}>
                                        <Card
                                            onMouseEnter={() => setHoveredCard(i)}
                                            onMouseLeave={() => setHoveredCard(null)}
                                            onClick={() => handleCourseClick(item)}
                                            sx={{
                                                position: 'relative',
                                                background: hoveredCard === i
                                                    ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%)'
                                                    : 'linear-gradient(145deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
                                                backdropFilter: 'blur(20px)',
                                                borderRadius: '20px',
                                                border: hoveredCard === i 
                                                    ? '2px solid rgba(59, 130, 246, 0.5)'
                                                    : '1px solid rgba(255, 255, 255, 0.1)',
                                                cursor: 'pointer',
                                                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                                transform: hoveredCard === i 
                                                    ? 'translateY(-8px) scale(1.03)' 
                                                    : 'translateY(0) scale(1)',
                                                boxShadow: hoveredCard === i
                                                    ? '0 20px 40px rgba(59, 130, 246, 0.25), 0 10px 20px rgba(0, 0, 0, 0.3)'
                                                    : '0 10px 25px rgba(0, 0, 0, 0.2)',
                                                overflow: 'hidden',
                                                height: { xs: 220, sm: 240, md: 260 },
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    background: hoveredCard === i 
                                                        ? 'linear-gradient(45deg, transparent 0%, rgba(59, 130, 246, 0.1) 50%, transparent 100%)'
                                                        : 'transparent',
                                                    transition: 'all 0.3s ease',
                                                    pointerEvents: 'none',
                                                },
                                                '&::after': hoveredCard === i ? {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: -2,
                                                    left: -2,
                                                    right: -2,
                                                    bottom: -2,
                                                    background: 'conic-gradient(from 0deg, #3b82f6, #8b5cf6, #3b82f6)',
                                                    borderRadius: '22px',
                                                    zIndex: -1,
                                                    animation: 'rotate 3s linear infinite',
                                                    '@keyframes rotate': {
                                                        '0%': { transform: 'rotate(0deg)' },
                                                        '100%': { transform: 'rotate(360deg)' },
                                                    }
                                                } : {}
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                image={item?.logo ? endpointsUrl + item?.logo : "img/folder-2.png"}
                                                alt={item?.name || "Course Image"}
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    transition: 'all 0.4s ease',
                                                    transform: hoveredCard === i ? 'scale(1.05)' : 'scale(1)',
                                                    filter: hoveredCard === i 
                                                        ? 'brightness(1.2) contrast(1.1) saturate(1.1)' 
                                                        : 'brightness(0.95) contrast(0.95)',
                                                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                                }}
                                            />

                                            {/* Gradient Overlay */}
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: '30%',
                                                    background: 'linear-gradient(transparent 0%, rgba(0, 0, 0, 0.3) 100%)',
                                                    opacity: hoveredCard === i ? 0.8 : 0.4,
                                                    transition: 'opacity 0.3s ease',
                                                }}
                                            />
                                        </Card>
                                    </Zoom>
                                </Grid>
                            ))}
                        </Grid>
                    </Fade>
                )}

                {/* Empty State */}
                {filterCourse?.length === 0 && (
                    <Fade in={isVisible} timeout={1000}>
                        <Box
                            sx={{
                                textAlign: 'center',
                                py: 8,
                                color: 'white',
                            }}
                        >
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
                                    borderRadius: '50%',
                                    width: 80,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mx: 'auto',
                                    mb: 3,
                                    backdropFilter: 'blur(10px)',
                                }}
                            >
                                <School sx={{ fontSize: '2.5rem', color: 'rgba(255, 255, 255, 0.5)' }} />
                            </Box>
                            <Typography variant="h6" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 1 }}>
                                No Test Series Available
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.5)' }}>
                                Check back later for new classroom test series
                            </Typography>
                        </Box>
                    </Fade>
                )}
            </Container>
        </Box>
    );
};
